import React from 'react'
import { Link } from 'react-router-dom'
import styles from '../CardArtiste/CardArtiste.module.css'
import { useTranslation} from 'react-i18next';

// import artist from '../../assets/artiste-sympas.jpg'

const CardArtiste = (props) => {

    const { t } = useTranslation();

    return (

            <div className={`${styles.cardArtistePrecis}  rounded-lg mx-1 shadow-lg m-3`}>
                <div className="cardNew">

                    <div className="card-body">
                        <div className="container-fluid">
                            <div className="row">

                                <div className="col-3 ">
                                        <div>
                                            {/* <img src={props.imgProfilRond} alt="photos du card" className={`${styles.outer} ${styles.imgGrey} img-fluid rounded-circle`} /> */}
                                            <div  className="img-fluid rounded-circle" style={{backgroundImage: `url(${props.imgProfilRond})`, height: 60+'px', width: 60+'px',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover' }}   />
                                        </div>
                                </div>

                                <div className="col-9">
                                    <h5 className="card-title">
                                        {props.NameArtist} 
                                    </h5>

                                    <div className="bg-bordeaux rounded-pill d-inline p-2 text-white m-1 ">
                                        {t(props.CategorieArtiste)}
                                    </div>
                                </div>

                            </div>
                        </div> 
                    </div>
                    

                    <div > 
                        <Link to ={'/artistes/' + props.NameURL} >
                            <figure>
                                <div   style={{backgroundImage: `url(${props.imgbg})`, height: 370+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover' }}   />
                            </figure>
                        </Link>
                    </div>
                </div>
            </div>
    )
}

export default CardArtiste


